import {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {css} from '@emotion/react';
import Container from '@material-ui/core/Container';
import FadeLoader from 'react-spinners/FadeLoader';
import api from 'api/Api';
import AskView from 'routes/AskView';
import RiskInfoView from 'routes/RiskInfoView';
import {useCookies} from 'react-cookie';
import {isMobile, deviceDetect, ConsoleView} from 'react-device-detect';

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
  text-align: center;
`;
const useStyles = makeStyles (theme => ({
  loading: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}));

const RedirectView = () => {
  const location = useLocation ();
  let redirectLink =
    location.pathname.split ('readonly/')[1] + location.search + location.hash;
  if (!redirectLink.startsWith ('http')) {
    redirectLink = 'http://' + redirectLink;
  }
  redirectLink = redirectLink.replace (
    /^((?:https|http):\/)([^\/].+)/,
    '$1/$2'
  );

  console.log (deviceDetect ());
  let {token} = useParams ();
  const navigate = useNavigate ();
  const classes = useStyles ();
  const [cookies, setCookie] = useCookies (['transform_policy']);
  let [loading, setLoading] = useState (true);
  let [askComponet, setAskComponet] = useState (false);
  let [riskComponet, setRiskComponet] = useState (false);
  let [redirectConfig, setRedirectConfig] = useState ({
    transform_policy: {
      method: '',
      cookies: false,
    },
    transform: null,
  });
  useEffect (async () => {
    if (!token) {
      setRedirectConfig ({
        transform_policy: {
          method: 'optional',
          cookies: false,
        },
        transform: true,
      });
      setLoading (false);
      return;
    }

    // if (cookies) {
    //   setRedirectConfig(cookies)
    //   return null;
    // }
    try {
      const res = await api.getRedirectMethod (token, {link: redirectLink});
      if (res && res.status == 200) {
        if (
          res.data.transform_policy.method != 'skip' &&
          cookies.transform_policy
        ) {
          res.data.transform_policy.method = cookies.transform_policy;
          res.data.transform_policy.withCookies = true;
        }
        // console.log(res.data)
        if ('gr_reputation' in res.data) {
          await api.callBackLog (
            token,
            res.data,
            redirectLink,
            'url_phishing / url_spam',
            deviceDetect ()
          );
          navigate ('/block', {state: {link: redirectLink, data: res.data}});
        }
        setRedirectConfig (res.data);
      } else {
        console.log ('>');
        navigate ('/401', {});
      }
    } catch (error) {
      console.log ('<');
      navigate ('/401', {});
    }

    setLoading (false);
  }, []);

  const redirect = target_link => {
    var link = document.createElement ('a');
    link.referrerPolicy = 'no-referrer';
    link.rel = 'noreferrer';

    link.href = target_link;
    link.click ();
  };
  useEffect (
    async () => {
      if (
        !isMobile ||
        (isMobile && !token) ||
        (isMobile && redirectConfig.transform_policy.mobile_redirect)
      ) {
        console.log ('??');
        switch (redirectConfig.transform_policy.method) {
          case 'enforce':
            console.log (redirectLink);
            redirectLink =
              redirectConfig.transform_policy.redirect_target + redirectLink;
            await api.callBackLog (
              token,
              redirectConfig,
              redirectLink,
              'isolation',
              deviceDetect ()
            );
            redirect (redirectLink);
            return null;
          case 'optional':
            setAskComponet (true);
            return null;
          case 'riskINFO':
            setRiskComponet (true);
            return null;
          case 'skip':
            await api.callBackLog (
              token,
              redirectConfig,
              redirectLink,
              'bypass',
              deviceDetect ()
            );
            redirect (redirectLink);
            return null;
        }
      }
    },
    [redirectConfig.transform_policy.method]
  );
  return (
    <Container maxWidth="md">

      <div className={classes.loading}>
        {console.log (redirectConfig)}
        {isMobile &&
          !redirectConfig.transform_policy.mobile_redirect &&
          token &&
          redirectConfig.transform_policy.method != '' &&
          !loading | riskComponet &&
          !loading
          ? <RiskInfoView
              token={token}
              redirectLink={redirectLink}
              data={redirectConfig}
            />
          : <div />}

        {askComponet
          ? <AskView
              token={token}
              redirectLink={redirectLink}
              redirectConfig={redirectConfig}
            />
          : <div />}

        <FadeLoader
          radius={5}
          height="20"
          width="7"
          margin="10px"
          color="#5DBB46"
          css={override}
          loading={loading}
        />
      </div>
    </Container>
  );
};

export default RedirectView;
